<template>
	<core-alert class="upsell-alert success" v-if="upsell">
		<div class="alert-message">
			<span>{{ upsell.message }}</span>
			<core-upgrade-button
				color="green"
				class="upsell-alert-button"
				utmMedium="TemplatesUpsellAlerts"
				:features="[upsell.feature]"
			>
				Upgrade to {{ upsell.level }}
			</core-upgrade-button>
		</div>
	</core-alert>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
	computed : {
		...mapState('templates', [ 'filters' ]),
		...mapGetters([ 'hasFeature' ]),
		upsell () {
			if (this.filters.device && 'mobile' === this.filters.device && !this.hasFeature('mobile-campaigns')) {
				return {
					message : 'Did you know that more traffic comes from mobile phones than any other device? Our mobile-optimized templates create a great user experience to maximize conversions.',
					feature : 'mobile',
					level   : 'Pro',
				}
			}

			if (this.filters.goals && 2 === this.filters.goals && !this.hasFeature('exit-trigger')) {
				return {
					message : 'Upgrade to Pro today and unlock the full power of Exit Intent®, our signature technology that converts abandoning website visitors into subscribers and customers.',
					feature : 'exit-intent',
					level   : 'Pro',
				}
			}

			if (this.filters.goals && 3 === this.filters.goals && !this.hasFeature('yesno-buttons')) {
				return {
					message : 'Upgrade to Pro today and get access to Yes / No Multi-Step forms, the perfect solution to redirect traffic and increase conversions based your visitor\'s preferences.',
					feature : 'yesno',
					level   : 'Pro',
				}
			}

			if (this.filters.goals && 4 === this.filters.goals && !this.hasFeature('countdown-element')) {
				return {
					message : 'Enhance your offers using urgency and scarcity with dynamic countdown timers. Upgrade to Pro today and unlock sales timers guaranteed to build buzz and increase conversions.',
					feature : 'countdown-timer',
					level   : 'Pro',
				}
			}

			if (this.filters.categories && 2 === this.filters.categories && !this.hasFeature('onsite-targeting')) {
				return {
					message : 'Upgrade to Growth today to personalize your campaigns using OnSite Retargeting®. Highlight customized offers to new visitors or existing subscribers for impressive results.',
					feature : 'onsite-retargeting',
					level   : 'Growth',
				}
			}

			if (this.filters.categories && 3 === this.filters.categories && !this.hasFeature('geo-targeting')) {
				return {
					message : 'Instantly personalize campaigns based on your visitor\'s location with Geo-Location Targeting. Upgrade today and deliver the perfect offer to the right person at the right time.',
					feature : 'geolocation',
					level   : 'Growth',
				}
			}

			return null
		},
	},
}
</script>
<style lang="scss">
.upsell-alert {
	margin-bottom: 30px;
	padding-right: 12px !important;

	.alert-message {
		width: 100%;
		display: flex !important;
		justify-content: space-between;
		align-items: center;

		& > span {
			padding-right: 50px;
		}

		a.button {
			min-width: 118px;
		}
	}
	&-button {
		flex-shrink: 0;
		text-align: center;
	}
}
</style>
